import { render, staticRenderFns } from "./FullDescription.vue?vue&type=template&id=722333e2"
import script from "./FullDescription.vue?vue&type=script&lang=js"
export * from "./FullDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports